import React from "react";

import { ITeam } from "apis";

import { PlayerField } from "./PlayerField";
import { ThreatField } from "./ThreatField";

interface ICornerKickPanelProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

export const CornerKickPanel = ({
  homeTeam,
  awayTeam,
}: ICornerKickPanelProps) => {
  return (
    <>
      <PlayerField homeTeam={homeTeam} awayTeam={awayTeam} />
      <ThreatField />
    </>
  );
};
